<section>
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.REPORT_VOLUNTARY_TAX_LIABILITY' | translate }}</h1>
    <div class="astral-page-header__actions">
      <astral-button variant="primary" size="small" type="button" icon="print" labelKey="PRINT_BTN" (click)="onPrintPages()"></astral-button>
      <astral-button variant="primary" size="small" type="button" icon="excel" labelKey="COMMON.EXCEL" (click)="exportExcel()"></astral-button>
    </div>
  </div>

  <form class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1">
      <app-autocomplete-remote-paged
        [service]="companyService"
        [defaultSearch]="'*'"
        [control]="form.controls['company']"
      ></app-autocomplete-remote-paged>
      <app-autocomplete-remote-paged
        [service]="propertyService"
        [defaultSearch]="'*'"
        [control]="form.controls['property']"
      ></app-autocomplete-remote-paged>
      <astral-select [control]="form.controls['onlyVoluntaryVat']" [itemsSource]="onlyVoluntarySelection"></astral-select>
      <astral-date-picker
        [control]="form.controls['calculationDate']"
        [model]="calculationDate"
        [label]="'REPORT.DISPLAY_DATE'"
        [isRequired]="true"
      ></astral-date-picker>
    </astral-layout-group>
    <div class="astral-filter-actions">
      <astral-button variant="primary" size="small" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
    </div>
  </form>

  @if (dataContext) {
    <app-expanded-list-view
      [columnDefinitions]="columnDefinitions"
      [itemsSource]="dataContext"
      [preferencesKey]="'report.voluntary-tax-liability'"
      (rowClick)="onExpandedContentRowClicked($event)"
    ></app-expanded-list-view>
  }
</section>
